'use client';

import { useSearchParams } from 'next/navigation';
import { testSlugs } from 'utils/helpers';

const CampaignScripts = ({ offeringData }) => {
  const searchParams = useSearchParams();

  const updateId = searchParams?.get('updateId');

  if (!offeringData) {
    return null;
  }

  return (
    <>
      {testSlugs.includes(offeringData.slug || '') && <meta name="robots" content="noindex" />}
      {!updateId && offeringData.id ? (
        <meta
          name="apple-itunes-app"
          content={`app-id=1560434961, app-argument=startengine://campaign?id=${offeringData.id}, affiliate-data=smart_banner_click&pt=122285963&mt=8"`}
        />
      ) : null}
    </>
  );
};

export default CampaignScripts;
